import * as React from 'react';

import {TooltipLabelWithLegend} from './tooltip-labels-with-legends';
import type {TooltipRowData} from './tooltip-types';

import styles from './tooltips.module.css';

type TooltipLabelsProps = {
    headingText: string;
    detailRows: Array<TooltipRowData>;
    includeTotal?: boolean;
    quotaRow?: TooltipRowData | null | undefined;
};

export function TooltipLabels({
    detailRows,
    quotaRow,
    includeTotal,
    headingText,
}: TooltipLabelsProps) {
    return (
        <div>
            <h4 className={styles['tooltip-heading--labels']}>{headingText}</h4>
            <table className={styles['tooltip-table']}>
                <tbody>
                    {detailRows.map((row) => (
                        <tr key={row.name}>
                            <TooltipLabelWithLegend {...row} />
                        </tr>
                    ))}
                    {includeTotal ? (
                        <tr className={styles['row--total']}>
                            <td className={styles['label-container']}>Total</td>
                        </tr>
                    ) : undefined}
                    {quotaRow ? (
                        <tr key={quotaRow.name} className={styles['row--padded']}>
                            <TooltipLabelWithLegend {...quotaRow} />
                        </tr>
                    ) : undefined}
                </tbody>
            </table>
        </div>
    );
}
